module.exports = __webpack_public_path__ + "img/RCUSA.cf18e336.svg";